import React from 'react';
import { MediaType } from '../../utils/api/api-utils';
import i18n from '../../i18n';
import QCXFinalCustomInputFileAlt from './QCXFinalCustomInputFileAlt';

export default function QCXFinalPdfInputFile({
  id,
  key,
  label,
  name,
  tooltipTitle = i18n.t('com.muralis.qcx.arquivo.uploadArquivoPDF'),
  disableRemoveControl = false,
  inputRef,
  multiple = false,
  ...restProps
}) {
  return (
    <QCXFinalCustomInputFileAlt
      id={id}
      key={key}
      label={label}
      name={name}
      accept={MediaType.APPLICATION_PDF}
      tooltipTitle={tooltipTitle}
      disableRemoveControl={disableRemoveControl}
      inputRef={inputRef}
      variant="list"
      multiple={multiple}
      {...restProps}
    />
  );
}
